// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__NJvbB","footer__container":"Footer_footer__container__gsToN","footer__info":"Footer_footer__info__sQZDm"};